/**
 * show a banner item.  a child of the banner block
 */
export function BannerItem({
  title,
  description,
}: {
  title: string;
  description: string;
}) {
  return (
    <div className="tw:flex tw:flex-col tw:justify-center tw:items-center tw:gap-2 tw:px-2 tw:min-w-[190px] tw:max-w-[190px] tw:lg:min-w-[220px] tw:lg:max-w-[220px]">
      <div className="tw:text-center tw:text-[2.5rem] tw:leading-[1.2]">
        {title}
      </div>
      <div className="tw:text-center tw:text-[1rem] tw:leading-none tw:font-semibold tw:uppercase">
        {description}
      </div>
    </div>
  );
}
